export default function commonEventListener(common) {
  return store => {
    common
      .addEventListener('room_user_enter', data => {
        store.commit('common/SET_DIFF_SERVER_TIME', data.eventTime)
      })
  }
}
